import Link from 'next/link';
import { useOrganizationContext } from '@/contexts/organization-context';
import Text from '@/components/basic/text';
import { cn } from '@/lib/utils';
import UserAvatar from './user-avatar';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { RoutePaths } from '@/consts/routes';

export function WorkspaceNavigation() {
  const { organizationId, organizationName, organizationLogos } =
    useOrganizationContext();
  const isWorkspaceEnabled = useFeatureFlagEnabled('workspace');

  const organizationLogo = organizationLogos && organizationLogos[0]?.url;

  if (!organizationName || !isWorkspaceEnabled) {
    return null;
  }

  return (
    <Link href={`${RoutePaths.Workspace}?organizationId=${organizationId}`}>
      <div
        className={cn(
          'flex max-h-12 cursor-pointer items-center justify-center gap-1 rounded-t-lg border-b-2 border-b-transparent px-4 py-3 hover:border-b-primary-600 hover:bg-primary-50'
        )}
      >
        {organizationName && (
          <UserAvatar
            imgClassName='object-cover'
            className='h-8 w-8'
            username={organizationName}
            imgSrc={organizationLogo}
          />
        )}
        <Text
          weight='medium'
          variant='body2'
          className='line-clamp-1 text-primary-600'
        >
          {organizationName}
        </Text>
      </div>{' '}
    </Link>
  );
}
